export default {
  en: {
    answer: {
      evidenceRequiredMessage: 'Your policy requires evidence for this answer.',
      evidenceNeedsAnswer: 'Answer the question to add evidence',
      evidenceSaveFailed: "We couldn't update the evidence. Try again.",
      evidenceStillScanning:
        "We're still checking a file you attached. Submit again in a moment, or remove the file.",
    },
    domainHeader: {
      unansweredCount: '{n} left to answer',
    },
    progressHero: {
      answered: '{answered} of {total} required questions answered',
      nothingToAnswer: 'No required questions to answer',
    },
    answeringView: {
      answeringOnBehalf: 'Answering on behalf of {supplier}',
      notFoundTitle: "We can't find this assessment",
      notFoundText: 'You may not have access to it.',
      domainNotRequiredTitle: "This domain isn't required",
      domainNotRequiredText: 'You can still answer its questions.',
      notRequiredQuestions: 'Questions not required',
    },
    submit: {
      button: 'Submit assessment',
      failed: "We couldn't submit the assessment. Try again.",
      calculating: 'Calculating compliance score',
    },
  },
};
